const AdminView = ({ settingsUrl, isVisible }) => {
  return (
    <>
      <div className="relative">
        <div className="z-10 absolute h-12 bg-base-100 rounded-full p-4 border border-base-content/20 text-xs mt-12 flex justify-center items-center left-1/2 -translate-x-1/2">
          {isVisible ? (
            <p className="text-accent-content text-l">
              <span className="font-semibold">Sidan är offentlig.</span>
            </p>
          ) : (
            <p className="text-accent-content text-l">
              <span className="font-semibold">Sidan är dold.</span>
            </p>
          )}

          <a href={settingsUrl}>
            <button className=" btn btn-secondary btn-xs mx-2">
              Uppdatera
            </button>
          </a>
        </div>
      </div>
    </>
  );
};

export default AdminView;
